import React, { useEffect, useState } from "react";
import {
  Container, Card, CardBody, CardHeader, Table, Button, Modal, ModalHeader,
  ModalBody, ModalFooter, Input, Label, Row, Col, Badge, Spinner,
} from "reactstrap";
import api from "./api";
import { aviso } from '../../../lib/dialogo';

const EMPTY = { nome: "", email: "", documento: "", telefone: "", empresa: "", status: "ativo", observacoes: "" };

const Clientes = () => {
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState("");
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [erro, setErro] = useState("");

  const carregar = async () => {
    setLoading(true);
    try { setLista(await api.get("/oplena/clientes") || []); }
    catch (e) { setErro(e.message); }
    finally { setLoading(false); }
  };
  useEffect(() => { carregar(); }, []);

  const abrirNovo = () => { setForm(EMPTY); setErro(""); setModal(true); };
  const abrirEdicao = (c) => { setForm({ ...EMPTY, ...c }); setErro(""); setModal(true); };

  const salvar = async () => {
    if (!form.nome.trim()) { setErro("Informe o nome."); return; }
    setSaving(true); setErro("");
    try {
      if (form.id) await api.put(`/oplena/clientes/${form.id}`, form);
      else await api.post("/oplena/clientes", form);
      setModal(false); await carregar();
    } catch (e) { setErro(e.message); }
    finally { setSaving(false); }
  };

  const excluir = async (c) => {
    if (!window.confirm(`Excluir o cliente "${c.nome}"?`)) return;
    try { await api.del(`/oplena/clientes/${c.id}`); await carregar(); }
    catch (e) { aviso(e.message, 'error'); }
  };

  const filtrados = lista.filter((c) =>
    [c.nome, c.email, c.empresa, c.documento].join(" ").toLowerCase().includes(busca.toLowerCase())
  );

  return (
    <div className="page-content">
      <Container fluid>
        <Card>
          <CardHeader className="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div>
              <h4 className="mb-0 fw-bold">Clientes</h4>
              <small className="text-muted">{lista.length} cadastrado(s)</small>
            </div>
            <div className="d-flex gap-2">
              <Input type="text" placeholder="Buscar..." value={busca} onChange={(e) => setBusca(e.target.value)} style={{ maxWidth: 220 }} />
              <Button color="primary" onClick={abrirNovo}><i className="fa-solid fa-plus me-1" /> Novo cliente</Button>
            </div>
          </CardHeader>
          <CardBody>
            {loading ? (
              <div className="text-center py-5"><Spinner /></div>
            ) : filtrados.length === 0 ? (
              <div className="text-center text-muted py-5">Nenhum cliente encontrado.</div>
            ) : (
              <Table responsive hover className="align-middle mb-0">
                <thead>
                  <tr><th>Nome</th><th>Contato</th><th>Documento</th><th>Empresa</th><th>Status</th><th className="text-end">Ações</th></tr>
                </thead>
                <tbody>
                  {filtrados.map((c) => (
                    <tr key={c.id}>
                      <td className="fw-semibold">{c.nome}</td>
                      <td><div>{c.email || "—"}</div><small className="text-muted">{c.telefone || ""}</small></td>
                      <td>{c.documento || "—"}</td>
                      <td>{c.empresa || "—"}</td>
                      <td><Badge color={c.status === "ativo" ? "success" : "secondary"}>{c.status}</Badge></td>
                      <td className="text-end">
                        <Button size="sm" color="outline-secondary" className="me-1" onClick={() => abrirEdicao(c)}><i className="fa-solid fa-pen" /></Button>
                        <Button size="sm" color="outline-danger" onClick={() => excluir(c)}><i className="fa-solid fa-trash" /></Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </CardBody>
        </Card>

        <Modal isOpen={modal} toggle={() => setModal(false)} centered>
          <ModalHeader toggle={() => setModal(false)}>{form.id ? "Editar cliente" : "Novo cliente"}</ModalHeader>
          <ModalBody>
            {erro && <div className="alert alert-danger py-2">{erro}</div>}
            <Row className="g-3">
              <Col md={12}><Label>Nome *</Label><Input value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} /></Col>
              <Col md={6}><Label>E-mail</Label><Input type="email" value={form.email || ""} onChange={(e) => setForm({ ...form, email: e.target.value })} /></Col>
              <Col md={6}><Label>Telefone</Label><Input value={form.telefone || ""} onChange={(e) => setForm({ ...form, telefone: e.target.value })} /></Col>
              <Col md={6}><Label>CPF/CNPJ</Label><Input value={form.documento || ""} onChange={(e) => setForm({ ...form, documento: e.target.value })} /></Col>
              <Col md={6}><Label>Empresa</Label><Input value={form.empresa || ""} onChange={(e) => setForm({ ...form, empresa: e.target.value })} /></Col>
              <Col md={6}><Label>Status</Label>
                <Input type="select" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
                  <option value="ativo">Ativo</option><option value="inativo">Inativo</option>
                </Input>
              </Col>
              <Col md={12}><Label>Observações</Label><Input type="textarea" rows={2} value={form.observacoes || ""} onChange={(e) => setForm({ ...form, observacoes: e.target.value })} /></Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={() => setModal(false)}>Cancelar</Button>
            <Button color="primary" onClick={salvar} disabled={saving}>{saving ? "Salvando..." : "Salvar"}</Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default Clientes;
